export default "__VITE_ASSET__BFxhlx0E__"